<script lang="ts">
  /**
   * One meal row on the Today screen. Number tile turns accent with a check
   * when the API says the meal is complete, warn when partly filled.
   */
  import Icon from './Icon.svelte';
  import SectionDots from './SectionDots.svelte';
  import type { DayMeal } from '../lib/types';

  let { meal, onopen }: { meal: DayMeal; onopen: (mealNo: number) => void } = $props();

  /** "Kaurahiutaleita" from "Kaurahiutaleita (30 g)" or "Raejuustoa, enintään 2 %". */
  function shortName(name: string): string {
    return name.split(' (')[0].split(',')[0].trim();
  }

  let description = $derived.by(() => {
    const chosen: string[] = [];
    for (const s of meal.sections) {
      for (const it of s.items) if (it.selected) chosen.push(shortName(it.name));
    }
    if (meal.vegTargetG !== null && meal.vegDone) chosen.push(`vihanneksia ${meal.vegTargetG} g`);
    if (chosen.length) return chosen.join(', ');
    const labels = meal.sections.map((s) => s.label.toLowerCase());
    if (meal.vegTargetG !== null) labels.push('vihannekset');
    return `Valitse ${labels.join(', ')}`;
  });

  let part = $derived(!meal.complete && meal.sectionsFilled > 0);
</script>

<button
  type="button"
  class="card meal"
  class:done={meal.complete}
  class:part
  onclick={() => onopen(meal.mealNo)}
  aria-label={`${meal.name}, ${meal.sectionsFilled}/${meal.sectionsTotal} osiota`}
>
  <div class="n">
    {#if meal.complete}<Icon name="check" />{:else}{meal.mealNo}{/if}
  </div>
  <div class="grow">
    <div class="t">{meal.name} <span class="hint">{meal.hint}</span></div>
    <div class="d">{description}</div>
    <SectionDots {meal} />
  </div>
  <div class="kc num">
    {meal.sectionsFilled}/{meal.sectionsTotal}<br /><span>osiota</span>
  </div>
</button>

<style>
  .card {
    background: var(--viisi-surface);
    border-radius: var(--viisi-radius);
    padding: 14px;
    box-shadow: var(--viisi-shadow);
  }
  .meal {
    display: grid;
    grid-template-columns: 44px 1fr auto;
    gap: 12px;
    align-items: center;
    text-align: left;
    width: 100%;
  }
  .n {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    font-family: var(--viisi-font-display);
    font-weight: 800;
    font-size: 18px;
    background: var(--viisi-surface-2);
    color: var(--viisi-ink-2);
  }
  .n :global(svg) { width: 22px; height: 22px; }
  .meal.done .n { background: var(--viisi-accent); color: var(--viisi-accent-ink); }
  .meal.part .n { background: var(--viisi-warn-soft); color: var(--viisi-warn); }
  .grow { flex: 1; min-width: 0; }
  .t { font-weight: 700; font-size: 15px; }
  .hint { font-weight: 500; color: var(--viisi-ink-3); font-size: 12px; }
  .d {
    color: var(--viisi-ink-2);
    font-size: 12.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .kc {
    font-family: var(--viisi-font-display);
    font-weight: 700;
    font-size: 14px;
    color: var(--viisi-ink-2);
    text-align: right;
  }
  .kc span { font-size: 11px; font-weight: 500; }
</style>
